import { render, staticRenderFns } from "./select.vue?vue&type=template&id=1fb91780&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"
import style0 from "./select.vue?vue&type=style&index=0&id=1fb91780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb91780",
  null
  
)

export default component.exports